import type { FaireProductEntity } from "../../entity_types/product";

export const p_8fgaztner7: FaireProductEntity = {
  token: "p_8fgaztner7",
  type: "product",
  name: "LOOSE CASUAL LONG LONG SLEEVE KNITTED CARDIGAN",
  brandToken: "b_m8aq2q3qv8",
  brandName: "Lily Clothing",
  imageUrl:
    "https://cdn.faire.com/fastly/6754fe51fa9d288597f853499f84b6201cec2444cebfd85c763dace8d26ad16c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e1ae103c3cddced1a226baab741f56cdef7cbeed57e8d25050d92e84825dd0d1.jpeg",
    "https://cdn.faire.com/fastly/b57d2bc5f1fa03ba722d45ee3658a746c2c6a34ad50cd20c0504875e4a93d91b.jpeg",
    "https://cdn.faire.com/fastly/c2cdef5a72c975ed36ae131344fa49a9b237e1836199f2dad1583b21bff2240f.jpeg",
    "https://cdn.faire.com/fastly/4c2ae33a57b9a1d7c9be75aae9e55b6f03b389cd67464869ce727f06aac5404b.jpeg",
    "https://cdn.faire.com/fastly/fc29de63074ef88225fd96c9ff526c158daa1e5b8e0e663818d4d61daca6b3ac.jpeg",
    "https://cdn.faire.com/fastly/dafb92765e4222ae6ff1ba0055670e58297cde352a074e3f38ca67052658cc81.jpeg",
    "https://cdn.faire.com/fastly/b4bbb07f3069f191013b56a1ea5e8c32b27ef44cbf3bde9939534458bfb961a1.jpeg",
    "https://cdn.faire.com/fastly/91b1abd7ac83a07ecc590e1414ba6492d7e9e1ee64d0661fd940ff87f9560351.jpeg",
    "https://cdn.faire.com/fastly/abb352d2d2e5b11ac0baab343cebb26f736e9b74811c6840cf570161fa3b255d.jpeg",
    "https://cdn.faire.com/fastly/d25ec356f4fbff4085bac6de3a50f0067066b02fd480ddccd31a089e21ffb9e1.jpeg",
    "https://cdn.faire.com/fastly/fa0789f83b56a92ed68afece24e57db6c46c348c6654785f71c4a1305238e43a.jpeg",
    "https://cdn.faire.com/fastly/495be4c1e72344c844ad223aadb410684650a11b65ca0398f315e164a1ee9afa.jpeg",
    "https://cdn.faire.com/fastly/943e57539cd3db06671a87f38ce1bc0258146b3cdf2e34119823dcd20ff8a1e4.jpeg",
    "https://cdn.faire.com/fastly/954b87142fcc605a609e596565d9404aebb8d549081df331ce70a35e78186ac9.jpeg",
    "https://cdn.faire.com/fastly/e2399362600f939822fc3745a7f46589939d99209bfe991fc671e5a8a7f66b59.jpeg",
    "https://cdn.faire.com/fastly/66d114a8ec1d6bffcc7b747b5131971d85830df4985b3a8ab54253fce74229b9.jpeg",
    "https://cdn.faire.com/fastly/2b15d6fd17c53991df07554a20c26fe3531a29a2ae3b9140bcd9542d876d2ebe.jpeg",
    "https://cdn.faire.com/fastly/4b0c5481ef20d3c70edb8589d1a7dfe783aff75a16a0d7deb05a431fe28a3be9.jpeg",
  ],
  priceDollars: 21.09,
  description:
    "LOOSE CASUAL LONG LONG SLEEVE KNITTED CARDIGAN\n100% ACRYLIC\nSIZES : S,M,L,XL,XXL\nMADE IN CHINA\n\nCardigan, women's cardigan, cardigan, large size cardigan, knitted cardigan, oversized cardigan, cardigan hoodie, summer cardigan, short cardigan, long cardigan, spring cardigan, 2024 new cardigan, winter cardigan, fashionable women's cardigan, cardigan shirt, cardigan button down cardigan, loose cardigan, summer cardigan, knitted outerwear, cardigan with pockets，cardigan sweater，mens cardigan，folklore cardigan，black cardigan，red cardigan，white cardigan，womens cardigan，cropped cardigan，       crochet cardigan，long cardigan，cashmere cardigan，granny square cardigan，oversized cardigan，knit cardigan，womens cardigan sweaters，chunky cardigan，gray cardigan，long cardigan clothing，lightweight cardigan，cropped cardigan sweater，crochet cardigan pattern",
  tags: [],
  msrpDollars: 42.18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:55.035Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
